import React from "react"
import { useScrollDepth } from "@components/hooks/hooks"
import { useUserDatalayer } from "@components/hooks/useUserDatalayer"

const AppHooksProvider = ({ children }) => {
  useScrollDepth() // Initialize scroll depth tracking
  useUserDatalayer() // Initialize user datalayer tracking

  return children
}

export default AppHooksProvider
